/*
ge-xss.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('geXss',['angular', 'inputPatterns', 'javascripts/shared/directives/ge-xss/i18n'], function() {

    // Module Dependencies
    var dependencies = ['Services.InputPatterns', 'Directives.GeXss.i18n'];

    function hasScript(content) {
        if (typeof content === 'undefined' || content === '') {
            return false;
        }
        var scriptMarkupRegExps = ['<[ ]*script[^>]*>', 'javascript:', '<[ ]*a[^>]*>', '<[ ]*input[^>]*>', '<[ ]*html[^>]*>', '<[ ]*img[^>]*>', 'href[^>]*>', '<%[^>]*'];
        var lowerCasedContent =
            (typeof content === 'string' ? content.toLowerCase() :
                    (content + '').toLowerCase()
            );
        for (var i = 0; i < scriptMarkupRegExps.length; i++) {
            var regExp = new RegExp(scriptMarkupRegExps[i]);
            if (lowerCasedContent.match(regExp) !== null) {
                return true;
            }
        }
        // if this point is reached, no script or markup was found
        return false;
    }

    // function checks arg for valid data type
    function hasValidDataType (content, datatype) {
        if (
            typeof datatype === 'undefined' ||
            (typeof datatype === 'string' && datatype === '')
        ) {
            // valid content if no format imposed
            return true;
        }
        // validate for date string input by creating a date instance
        // with the provided string and inspecting its status
        if (datatype === 'date') {
            var date = new Date(content);
            if (isNaN(date.getDate())) {
                return false;
            } else {
                return true;
            }
        };
        return false;
    };

    // function checks arg for valid input pattern
    function hasValidInputPatterns(content, inputPatterns, datatype) {
        var formatRegExp = inputPatterns[datatype];
        // if no datatype string was passed in
        if (typeof formatRegExp === 'undefined') {
            // return true (i.e., no format violation)
            return false;
        }
        // if valid datatype string was passed
        // return the result of regexp test for that format
        return formatRegExp.test(content + '');
    }

    // Module Definition
    var mod = angular.module('Directives.GeXss', dependencies);

    // Directive definition
    mod.directive('geXss', ['$rootScope', 'inputPatterns', 'Directives.GeXss.i18n', '$filter', '$timeout',
        /**
         * Finds the selected user in the list of added users.
         *
         * @return
         *      name: 'geXss',  // controller name, prevents collisions with other directives
         *      restrict: 'A',  // apply to occurrences 'ge-xss' attribute
         */
        function ($rootScope, inputPatterns, i18n, $filter, $timeout) {
            return {
                name: 'geXss',
                restrict: 'A',
                /**
                 * gePattern = <input pattern>
                 * onScript = <callback function>
                 * onInvalid = <callback function>
                 * resetOnScript = <boolean to reset input field if scripting detected>
                 */
                scope: {
                    gePattern: '@',
                    onScript: '&',
                    onInvalid: '&',
                    resetOnScript: '@'
                },
                require: '?ngModel',
                link: function (scope, iElement, attributes, ngModel) {
                    scope['model'] = iElement.val();
                    // function that scans arg for any scripting or markup content
                    // Detect changes to input fields by attaching
                    // a listener on 'change' or 'blur' event on the element where
                    // the directive is applied
                    var thatElement = iElement;

                    function handleCallback(formEl, scriptsources) {
                        // if scripting callback was provided
                        // Using scope.onScript()
                        if (typeof scope.onScript() !== 'undefined') {
                            // call scripting callback
                            // passing SCRIPTING DETECTED string literal and element node
                            scope.onScript()(i18n.getMessages()['scriptingDetectedCAPS'], thatElement[0]);
                        }
                            // else if scripting call back was not provided
                        // call Notification service to display a message
                        else {
                            // calling notification service to display script error message
                            $timeout(function () {
                                console.log("It looks like you are trying to enter a script. Scripts are not allowed in form fields.");
                            });
                        }
                        // invalidate parent form (if found)
                        // by adding/removing the ng-invalid/ng-valid classes
                        if (formEl && formEl[0] && formEl[0].tagName === 'FORM') {
                            scriptsources.push(thatElement[0].name);
                            formEl.addClass('ng-invalid').removeClass('ng-valid');
                            formEl.data('scriptsources', scriptsources);
                        }
                        // if reset-on-script attribute is present
                        // reset input field value to empty
                        if (typeof scope.resetOnScript !== 'undefined') {
                            if(ngModel){
                                // This will set the value in ng-Model of the element
                                ngModel.$setViewValue('');
                                // This will actually reflect the value on HTML element
                                ngModel.$render();
                            } else {
                                iElement.val('');
                            }

                        }
                    };

                    // set form class to ng-valid/invalid depending on
                    // the absence of scripting in other child input fields
                    function updateClassOfChildElements(formEl, scriptsources) {
                        // if there is a parent form
                        if (formEl && formEl[0] && formEl[0].tagName === 'FORM') {

                            for (var i = 0; i < scriptsources.length; i++) {
                                if (thatElement[0].name === scriptsources[i]) {
                                    scriptsources.splice(i, 1);
                                    break;
                                }
                            }
                            // if the array of names of elements
                            // containing script is non-empty
                            if (scriptsources.length > 0) {
                                // mark the form as invalid
                                formEl.removeClass('ng-valid').addClass('ng-invalid');
                            }
                            else {
                                // else mark the form as valid
                                formEl.removeClass('ng-invalid').addClass('ng-valid');
                            }
                            // update the data of array of element
                            // names and attach to the form element
                            formEl.data('scriptsources', scriptsources);
                        }
                    };

                    // Validates the value of element against inputPatterns
                    function checkInvalidFormat(val, thatElement) {
                        var datatype = scope.gePattern;
                        // if valid pattern was provided and invalid format was detected and invalid format callback was provided
                        if (typeof datatype !== 'undefined' &&
                            (  !hasValidInputPatterns(val, inputPatterns, datatype) &&
                                !hasValidDataType(val, datatype)
                            ) &&
                            typeof scope.onInvalid() !== 'undefined') {
                            // call invalid callback
                            // passing INVALID FORMAT string literal and element node
                            scope.onInvalid()(i18n.getMessages()['invalidFormatCAPS'], thatElement[0]);
                        }
                    };

                    // locate parent form for later use on
                    // determining its enable/disable state
                    function locateParentElement(formEl, scriptsources) {
                        while ( formEl && formEl[0] && formEl[0].tagName !== 'FORM') {
                            formEl = formEl.parent();
                        }
                        // if parent form was located
                        if (formEl && formEl[0] && formEl[0].tagName === 'FORM') {
                            scriptsources = formEl.data('scriptsources');
                            scriptsources = scriptsources || [];
                        }
                    };

                    iElement.on('change blur', function () {
                        var val = thatElement.val();
                        if (typeof val === 'undefined' || val === '') {
                            return;
                        }

                        var formEl = thatElement.parent();
                        var scriptsources = [];

                        // locate parent form for later use on
                        // determining its enable/disable state
                        locateParentElement(formEl, scriptsources);

                        // if scripting was detected
                        if (hasScript(val)) {

                            // if scripting callback was provided
                            // Using scope.onScript()
                            handleCallback(formEl, scriptsources);

                            // set form class to ng-valid/invalid depending on
                            // the absence of scripting in other child input fields
                            updateClassOfChildElements(formEl, scriptsources);

                            // skip format validation if scripting was detected
                            return;
                        }

                        // Validates the value of element against inputpatterns
                        checkInvalidFormat(val, thatElement);
                    });
                }
            };
        }
    ]);
});
